class TopbarHeightWatcher extends HTMLDivElement {
  constructor() {
    super();
    this.topbar = document.querySelector('.topbar-js');
    this.observer = null;
  }

  connectedCallback() {
    this.initObserver();
    this.updateHeights();
  }

  initObserver() {
    if (!this.topbar) return;

    this.observer = new ResizeObserver(() => {
      this.updateHeights();
    });

    this.observer.observe(this.topbar);
  }

  updateHeights() {
    requestAnimationFrame(() => {
      const topbarHeight = Math.round(this.topbar?.offsetHeight || 0);
      document.documentElement.style.setProperty('--topbar-height', `${topbarHeight}px`);
    });
  }
}
customElements.define('topbar-height-watcher', TopbarHeightWatcher, { extends: 'div' });